import { defineMessages } from 'utils/intl';

export default defineMessages({
  popularity: 'Popularności',
  priceAsc: 'Cena - rosnąco',
  priceDesc: 'Cena - malejąco',
});
